
import { useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Menu from "../components/Menu";
import Loading from "../components/Loading";

import api from "../services/api";

export default function TipoParada() {
    const [nome, setNome] = useState('');
    const [tipos, setTipos] = useState([]);

    const [display, setDisplay] = useState(false);
    const [loading, setLoading] = useState(false);

    const toast = useRef(null);

    const handleSubmit = () => {
        if (nome === '')
            return;
        setLoading(true);
        api.post('cadastros/tipos-parada/store', {
            "nome": nome
        }).then((response) => {
            let copy = [...tipos];
            copy.push(response.data.tipo);
            setTipos(copy);

            hideDialog();
            setLoading(false);
            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleDelete = (rowData, rowIndex) => {
        confirmDialog({
            header: 'Confirmação',
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: 'Cancelar',
            rejectClassName: 'p-button-secondary',
            message: 'Você tem certeza que deseja excluir esse registro?',
            accept: () => {
                setLoading(true);
                api.post('cadastros/tipos-parada/delete', {
                    'tipo_id': rowData.id
                }).then((response) => {
                    let copy = [...tipos];
                    copy.splice(rowIndex, 1); 
                    setTipos(copy);
                    
                    setLoading(false);
                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: response.data.message
                    });
                }).catch((error) => {
                    setLoading(false);
                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: error.response.data.message
                    });
                });
            }
        });
    }

    const hideDialog = () => {
        setDisplay(false);
        setNome('');
    }

    useEffect(() => {
        setLoading(true);
        api.get('cadastros/tipos-parada').then((response) => {
            setTipos(response.data);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }, []);

    if(loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog onHide={hideDialog} breakpoints={{ '960px': '90vw' }} style={{ minWidth: '30vw' }} visible={display} header="Cadastrar" footer={() => (
                <div>
                    <Button className="p-button-secondary" label="Cancelar" onClick={hideDialog} />
                    <Button className="p-button-success" label="Salvar" loading={loading} onClick={handleSubmit} />
                </div>
            )}>
                <div className="p-fluid">
                    <div className="p-field">
                        <InputText
                            onChange={e => setNome(e.target.value)}
                            placeholder="Nome do tipo de parada"
                            type="text"
                            value={nome}
                        />
                    </div>
                </div>
            </Dialog>

            <Card className="p-m-3" header={() => (
                <div className="p-d-flex p-flex-row p-jc-between p-ai-start" style={{ width: '100%' }}>
                    <h1 className="p-m-3">Tipos de Parada</h1>
                    <Button className="p-button-primary p-mr-3 p-mt-3" icon="pi pi-plus" onClick={() => setDisplay(true)} />
                </div>
            )} >
                <DataTable value={tipos} >
                    <Column header="ID" field="id" style={{ width: '25%' }} />
                    <Column header="Nome" field="nome" style={{ width: '50%' }}/>
                    <Column header="Ações" style={{ width: '25%' }} body={(rowData, index) => (
                        <div>
                            <Button className="p-button-danger" icon="pi pi-trash" onClick={() => handleDelete(rowData, index.rowIndex)} />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}